window.chooseProductVatUpdateMode = function () {
  return new Promise(function (resolve) {
    $('#product-vat-update-modal').remove();
    const modal = $(
      '<div class="modal fade" id="product-vat-update-modal" tabindex="-1" role="dialog" aria-hidden="true">' +
        '<div class="modal-dialog modal-dialog-centered" role="document">' +
          '<div class="modal-content">' +
            '<div class="modal-header">' +
              '<h5 class="modal-title">Endre MVA</h5>' +
              '<button type="button" class="close" data-dismiss="modal" aria-label="Lukk"><span aria-hidden="true">&times;</span></button>' +
            '</div>' +
            '<div class="modal-body">Vil du endre utpris eller kalkyle når MVA endres?</div>' +
            '<div class="modal-footer">' +
              '<button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Avbryt</button>' +
              '<button type="button" class="btn btn-outline-primary product-vat-mode" data-mode="calculation">Kalkyle</button>' +
              '<button type="button" class="btn btn-primary product-vat-mode" data-mode="output_price">Utpris</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
    let selectedMode = null;

    $('body').append(modal);
    modal.on('click', '.product-vat-mode', function () {
      selectedMode = $(this).data('mode');
      modal.modal('hide');
    });
    modal.on('hidden.bs.modal', function () {
      modal.remove();
      resolve(selectedMode);
    });
    modal.modal('show');
  });
};
